<template>
  <a-drawer
:maskClosable="false"
width="35%"
:label-col="4"
:wrapper-col="14"
:visible="open"
@close="cancel"
:destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-alert v-if="role === 'admin'" message="超级管理员角色信息 不可更改" banner />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="状态" prop="status">
        <!-- 数据字段存储 '0'正常 '1'停用 这是原系统的问题-->
        <a-radio-group v-model="form.tenantType" button-style="solid" @change="handleChange">
          <a-radio-button :value="1">企业品牌</a-radio-button>
          <a-radio-button :value="2">经销商</a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="菜单权限">
        <a-checkbox @change="handleCheckedTreeExpand($event)"> 展开/折叠 </a-checkbox>
        <a-checkbox @change="handleCheckedTreeNodeAll($event)"> 全选/全不选 </a-checkbox>
        <a-checkbox
          @change="handleCheckedTreeConnect($event)"
          :checked="form.menuCheckStrictly"
          :disabled="menuCheckedKeys.length > 0"
        >
          父子联动
          <a-tooltip>
            <template slot="title"> 当勾选项为空时方可切换模式， 可以点击”全不选“后再次切换。 </template>
            <a-icon type="question-circle-o" />
          </a-tooltip>
        </a-checkbox>
        <a-tree
          v-model="menuCheckedKeys"
          checkable
          :checkStrictly="!form.menuCheckStrictly"
          readonly
          :expanded-keys="menuExpandedKeys"
          :auto-expand-parent="autoExpandParent"
          :tree-data="menuOptions"
          @check="onCheck"
          @expand="onExpandMenu"
          :replaceFields="defaultProps"
        />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" placeholder="请输入" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control" v-if="role !== 'admin'">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { menuDeTail, tenantAdd } from '@/api/system/role'
import { treeselect as menuTreeselect, roleMenuTreeselect } from '@/api/system/menu'
import { treeFindParentIds, findAllIDs } from '@/utils/ruoyi'
export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: false,
    },
  },
  components: {},
  data() {
    return {
      submitLoading: false,
      menuExpandedKeys: [],
      autoExpandParent: false,
      menuCheckedKeys: [],
      halfCheckedKeys: [],
      menuOptions: [],
      formTitle: '',
      role: '', // 角色如果是admin的话，不显示保存按钮
      // 表单参数
      form: {
        id: undefined,
        tenantType: 1,
        ids: [],
        menuCheckStrictly: true,
      },
      open: false,
      menuExpand: false,
      menuNodeAll: false,
      rules: {
        roleName: [{ required: true, message: '角色名称不能为空', trigger: 'blur' }],
        roleKey: [{ required: true, message: '权限字符不能为空', trigger: 'blur' }],
        roleSort: [{ required: true, message: '显示顺序不能为空', trigger: 'blur' }],
      },
      defaultProps: {
        children: 'children',
        title: 'label',
        key: 'id',
      },
    }
  },
  filters: {},
  created() {
    this.getMenuTreeselect()
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    onExpandMenu(expandedKeys) {
      this.menuExpandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    /** 查询菜单树结构 */
    getMenuTreeselect() {
      menuTreeselect().then((response) => {
        console.log(response.data, '的点点滴滴')
        this.menuOptions = response.data
        // let arr = []
        // response.data.forEach((v) => {
        //   console.log(v, '地对地导弹')
        //   arr.push(v.id)
        // })
        // this.menuOptions = response.data
      })
    },
    // 所有菜单节点数据
    getMenuAllCheckedKeys() {
      // 全选与半选
      return this.menuCheckedKeys.concat(this.halfCheckedKeys)
    },
    getAllMenuNode(nodes) {
      if (!nodes || nodes.length === 0) {
        return []
      }
      nodes.forEach((node) => {
        this.menuCheckedKeys.push(node.id)
        return this.getAllMenuNode(node.children)
      })
    },
    // 点击选择类型
    handleChange(e) {
      // console.log(e, this.form.tenantType, 'sddd的点点滴滴')
      this.handleUpdate(this.form.tenantType)
    },
    handleCheckedTreeNodeAll(value) {
      if (value.target.checked) {
        this.getAllMenuNode(this.menuOptions)
      } else {
        this.menuCheckedKeys = []
        this.halfCheckedKeys = []
      }
    },
    handleCheckedTreeExpand(value) {
      if (value.target.checked) {
        const treeList = this.menuOptions
        for (let i = 0; i < treeList.length; i++) {
          this.menuExpandedKeys.push(treeList[i].id)
        }
      } else {
        this.menuExpandedKeys = []
      }
    },
    // 树权限（父子联动）
    handleCheckedTreeConnect(value) {
      this.form.menuCheckStrictly = !this.form.menuCheckStrictly
    },
    /** 根据角色ID查询菜单树结构 */
    getRoleMenuTreeselect(roleId) {
      return roleMenuTreeselect(roleId).then((response) => {
        this.menuOptions = response.data.menus
        this.menuCheckedKeys = response.data.checkedKeys
        return response.data
      })
    },
    onCheck(checkedKeys, info) {
      console.log(info, 'checkedKeyscheckedKeys')
      if (!this.form.menuCheckStrictly) {
        let currentCheckedKeys = []
        if (this.menuCheckedKeys.checked) {
          currentCheckedKeys = currentCheckedKeys.concat(this.menuCheckedKeys.checked)
        }
        if (this.menuCheckedKeys.halfChecked) {
          currentCheckedKeys = currentCheckedKeys.concat(this.menuCheckedKeys.halfChecked)
        }
        this.menuCheckedKeys = currentCheckedKeys
      } else {
        // 半选节点
        this.halfCheckedKeys = info.halfCheckedKeys
        this.menuCheckedKeys = checkedKeys
      }
    },
    onClose() {
       const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          that.open = false
        },
        onCancel() {},
      })
    },
    // 取消按钮
    cancel() {
      this.onClose()
    },
    // 表单重置
    reset() {
      if (this.$refs.menu !== undefined) {
        this.menuCheckedKeys = []
        this.halfCheckedKeys = []
      }
      this.menuExpand = false
      this.menuNodeAll = false
      this.menuExpandedKeys = []
      this.autoExpandParent = false
      this.menuCheckedKeys = []
      this.halfCheckedKeys = []
      this.form = {
        id: undefined,
        tenantType: 1,
        ids: [],
        menuCheckStrictly: true,
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.getMenuTreeselect()
      this.open = true
      // this.formTitle = '添加角色'
      this.handleUpdate(this.form.tenantType)
    },
    /** 修改按钮操作 */
    handleUpdate(e) {
      console.log(e, 'ddddddmmmm')
      // this.reset()
      // const roleId = row ? row.id : ids
      // const roleMenu = this.getRoleMenuTreeselect(roleId)
      menuDeTail({ tenantType: e }).then((response) => {
        console.log(response, 'responseresponseresponse')
        console.log(this.menuOptions, 'roleMenuroleMenu========')
        // this.form = response.data
        this.open = true
        // this.role = response.data.roleKey
        this.$nextTick(() => {
          this.menuCheckedKeys = response.data.ids
          // if (this.form.menuCheckStrictly) {
          //   this.menuCheckedKeys.forEach((id) => {
          //     const parentIds = treeFindParentIds(this.menuOptions, id)
          //     parentIds.forEach((nodeId) => {
          //       if (!this.menuCheckedKeys.includes(nodeId) && this.halfCheckedKeys.includes(nodeId)) {
          //         this.halfCheckedKeys.push(nodeId)
          //       }
          //     })
          //   })
          // }
          if (this.form.menuCheckStrictly) {
            this.menuCheckedKeys.forEach((id) => {
              const parentIds = treeFindParentIds(this.menuOptions, id)
              parentIds.forEach((nodeId) => {
                if (!this.menuCheckedKeys.includes(nodeId) && !this.halfCheckedKeys.includes(nodeId)) {
                  this.halfCheckedKeys.push(nodeId)
                  console.log(this.halfCheckedKeys, 'this.halfCheckedKeysthis.halfCheckedKeys')
                }
              })
            })
          }
        })
        this.formTitle = '修改权限'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
       this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          // this.form.ids = this.getMenuAllCheckedKeys()
          const ids = this.getMenuAllCheckedKeys()
          console.log(ids, '测试数据长度===1111')
          this.form.ids = [...new Set(ids)]
          // console.log(this.halfCheckedKeys, 'halfCheckedKeyshalfCheckedKeys')
          // console.log(this.menuCheckedKeys, 'this.menuCheckedKeysthis.menuCheckedKeys')
          // console.log(this.form.ids, 'idsidsidsidsidsid')
          // return true
          // this.form.ids = this.menuCheckedKeys
          console.log(this.form.ids.length, '测试数据长度===')
          tenantAdd(this.form)
            .then((res) => {
              if (res.success) {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              } else {
                this.$message.error(`修改失败，${res.message}`)
              }
              setTimeout(() => {
                this.submitLoading = false
              }, 600)
            })
            .finally(() => {
              setTimeout(() => {
                this.submitLoading = false
              }, 600)
            })
        } else {
          return false
        }
      })
    },
  },
}
</script>
